import React, { Fragment } from "react";
import PropTypes from "prop-types";
import errorsType from "../types/errorsType";
import {
  Field,
  Label,
  LabelText,
  Required,
  Input,
  Select,
  Option,
  ContractDuration,
  DurationElement,
  Salary,
  SalaryElement,
  Error,
} from "../styles/edit-form-styles";
import contractJobProfileType from "../types/contractJobProfileType";

const Contract = (props) => {
  const {
    salaryMin,
    contractDuration,
    contractDurationInterval,
    inputOnChange,
    errors,
    jobProfile,
    currencyOptions,
  } = props;

  const { currencySymbol, currencyId } = jobProfile;

  return (
    <Fragment>
      <Salary>
        <SalaryElement>
          <Label htmlFor="day-rate">
            <LabelText>
              Day Rate in {currencySymbol} <Required>*</Required>
            </LabelText>
          </Label>
          <Input
            error={!!errors.salary_min}
            type="text"
            name="salaryMin"
            id="day-rate"
            value={salaryMin}
            onChange={inputOnChange}
          />
        </SalaryElement>
        <SalaryElement />
        <SalaryElement>
          <Label htmlFor="currency">
            <LabelText>
              Currency <Required>*</Required>
            </LabelText>
          </Label>
          <Select
            error={!!errors.currency_id}
            onChange={inputOnChange}
            name="currencyId"
            id="currency"
            value={currencyId}
            title="Please select a currency..."
          >
            <Option value="">Please select a currency...</Option>
            {currencyOptions.map((currencyOption) => (
              <Option key={currencyOption.id} value={currencyOption.id}>
                {currencyOption.name}
              </Option>
            ))}
          </Select>
        </SalaryElement>
        {errors.salary_min && (
          <Error>{`For day rate ${errors.salary_min}.`}</Error>
        )}
        {errors.currency_id && <Error>Please select a currency.</Error>}
      </Salary>
      <Field>
        <ContractDuration>
          <DurationElement>
            <Label htmlFor="duration">
              <LabelText>
                Duration <Required>*</Required>
              </LabelText>
            </Label>
            <Input
              error={!!errors.contract_duration}
              type="text"
              name="contractDuration"
              id="duration"
              value={contractDuration}
              onChange={inputOnChange}
            />
          </DurationElement>
          <DurationElement>
            <Label htmlFor="interval">Interval</Label>
            <Select
              error={!!errors.contract_duration_interval}
              onChange={inputOnChange}
              id="interval"
              name="contractDurationInterval"
              title="Please select an interval..."
              value={contractDurationInterval}
            >
              <Option value="">Please select an interval...</Option>
              <Option value="days">Days</Option>
              <Option value="weeks">Weeks</Option>
              <Option value="months">Months</Option>
            </Select>
          </DurationElement>
          {(errors.contract_duration || errors.contract_duration_interval) && (
            <Error>Contract duration or interval cannot be blank</Error>
          )}
        </ContractDuration>
      </Field>
    </Fragment>
  );
};

Contract.propTypes = {
  salaryMin: PropTypes.number.isRequired,
  contractDuration: PropTypes.number.isRequired,
  contractDurationInterval: PropTypes.string.isRequired,
  inputOnChange: PropTypes.func.isRequired,
  errors: errorsType.isRequired,
  jobProfile: contractJobProfileType.isRequired,
};

export default Contract;
